export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 34 34" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1462.000000, -2604.000000)">
                    <g transform="translate(1462.000000, 2604.000000)">
                        <polygon
                            fill="currentColor"
                            points="15.1916796 19.7877334 11.9145311 16.5338274 10.52 17.9283584 15.1916796 22.600038 24.8139468 12.9777728 23.4194164 11.56"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
